module.exports = __webpack_public_path__ + "static/CVS-CATCH-DLB-HS-Policy-Change-Ed-Guide-3897b0596d9a443a7f92a54a8c5a4e2a.pdf";